const groupsPh = ["DXP_Opslink_ExternalUsers", "DXP_Russia_Users", "DXP_GPS_ExternalUsers", "DXP_Food_ExternalUsers"]
export default {
  getGroupPh(group) {
    var val = groupsPh.indexOf(group) > -1
    return val;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/group-phone.js